import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";
import { basePixelAmount } from "@store/Framework/Common/Utilities/unitHelper";
import Styleguide from "@store/Framework/Types/Styleguide";
import { lazyLoadKeyframes } from "@store/Themes/common/mixins/lazyload";
import { loadingDotsKeyFrames } from "@store/Themes/common/mixins/typography";
import { css } from "styled-components";

const globalStyle: Styleguide["globalStyle"] = {
    css: css`
        ${lazyLoadKeyframes()}
        ${loadingDotsKeyFrames()}
	
	    html {
            font-size: ${basePixelAmount}px;
        }

        body {
            ${x => x.theme.typography.body.css};
        }

        /* -- CMS Adjustments ---------------------------------------------------------- */

        [class^="AddContainer"] [class^="IconContainer"] i {
            color: inherit;
        }

        [data-zone-single] [class^="AddContainer"]:not(:first-child) {
            display: none;
        }

        /* -- Form ------------------------------------------------------------ */

        input,
        textarea {
            &::placeholder {
                color: ${getColor("placeholder")};
                opacity: 1;
            }

            &:disabled,
            &.disabled {
                &::placeholder {
                    color: ${getColor("placeholder.disabled")};
                }
            }
        }

        fieldset {
            width: 100%;
            padding: 0;
            margin: 0;
            border: 0;
        }

        /* stylelint-disable property-no-vendor-prefix */
        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
        input[type="number"] {
            -moz-appearance: textfield !important;
        }
        /* stylelint-enable property-no-vendor-prefix */

        input:placeholder-shown::-webkit-search-cancel-button {
            display: none;
        }

        input:not(:placeholder-shown)::-webkit-search-cancel-button {
            padding: ${pxToRem(1)};
            margin: 0 ${pxToRem(14)};
            cursor: pointer;
        }

        /* -- Print ----------------------------------------------------------- */

        @media print {
            body {
                font-size: inherit !important;
            }

            h1 {
                font-size: 26px !important;
            }
        }

        /* Store Custom Code - Live Chat ----------------------------------------- */
        .embeddedServiceHelpButton .helpButton .uiButton {
            background-color: #00305e !important;
            font-family: Verdana, sans-serif;
        }
    `,
};

export default globalStyle;
